import { createRoot } from 'react-dom/client';
import * as React from "react";
import CommentGame from "./src/CommentGame";

const container = document.getElementById("root");
const root = createRoot(container!);
root.render(<CommentGame />);
